<template>
  <WhitePapersPage
    :paperTitle="'White Papers'"
    :whitePaperItems="items"
    :isRecentPapers="true"
  />
</template>

<script>
  import axios from 'axios';
  import store from '../../store';
  import moment from 'moment';
  import WhitePapersPage from './white-papers-page.vue';

  export default {
    data() {
      return {
        items: [],
      };
    },
    props: {
      query: String,
      paperPage: String,
    },
    components: {
      WhitePapersPage,
    },
    async mounted() {
      this.getWhitePapers();
    },
    methods: {
      async getWhitePapers() {
      /*  API call to server: GET /api/resources/whitepapers  */
      await axios
        .get('/api/resources/whitepapers')
        .then((response) => {
          this.items = response.data.Items.sort((a, b) => new Date(a.date) < new Date(b.date) ? 1 : -1);
          const today = moment().valueOf();
          const fromTheLastSixMonths = moment().subtract(6, 'months').valueOf();
          this.items = this.items.filter(({ date }) => (moment(date).valueOf() > fromTheLastSixMonths) && (moment(date).valueOf() < today));
          store.commit('setWhitePaperItems', this.items);
        })
        .catch((error) => {
          console.error(error);
        });
      }
    }
  }
</script>
